import { usePracticeModal } from '@widgets/NewPracticeModal';

import { Heading } from '@shared/ui';
import { DashboardContainer } from '@shared/ui/layouts';

import { DeadlineCard } from './DeadlineCard';
import { PracticeCard } from './PracticeCard';
import { RecentTestsCard } from './RecentTestsCard';
import { ScoreCard } from './ScoreCard';
import { SectionCard } from './SectionCard';
import { buildScoreChartData, buildSectionCardData, dashboardMockData } from '../model/mockData';

export const DashboardPage = () => {
  const { openPracticeModal } = usePracticeModal();
  const { deadlineCard, practices, scoreCard, testHistory } = dashboardMockData;
  const scoreChartData = buildScoreChartData(testHistory);
  const sections = buildSectionCardData(testHistory);

  return (
    <DashboardContainer>
      <div className="flex flex-col gap-5">
        <div
          className="
            grid h-52 max-w-full grid-cols-[minmax(0,3fr)_minmax(16rem,1.2fr)] justify-center
            gap-x-4
          "
        >
          <ScoreCard {...scoreCard} chartData={scoreChartData} />
          <DeadlineCard {...deadlineCard} />
        </div>

        <div
          className="
            grid max-w-full grid-cols-1 justify-center gap-x-10 gap-y-4 pt-2 pb-8
            lg:grid-cols-[minmax(0,2fr)_minmax(16rem,1fr)]
          "
        >
          <div>
            <Heading className="mt-4" aboveCard>
              Sections
            </Heading>
            <div className="mt-4 flex flex-col gap-4">
              {sections.map((section) => (
                <SectionCard key={section.title} {...section} />
              ))}
            </div>
          </div>

          <div
            className="
              grid grid-cols-2 gap-6
              lg:grid-cols-1
            "
          >
            <div>
              <Heading className="mt-4" aboveCard>
                Practice
              </Heading>

              <div className="mt-4 flex flex-col gap-2">
                {practices.map(({ action, ...practice }) => (
                  <PracticeCard
                    key={practice.title}
                    {...practice}
                    onClick={() => {
                      openPracticeModal(action);
                    }}
                  />
                ))}
              </div>
            </div>

            <div>
              <Heading className="mt-4" aboveCard>
                Recent Tests
              </Heading>
              <RecentTestsCard tests={testHistory} className="mt-4" />
            </div>
          </div>
        </div>
      </div>
    </DashboardContainer>
  );
};
